import store, { getStoreState } from 'config/store'
import { getEmbedThemeValueOrDefault, getPardotVisitorId } from 'modules/embed/selectors'
import { receiveCookieDomain } from 'modules/session/actions'
import { receiveIntegrationCookies } from 'modules/session/actions'
import qs from 'query-string'
import { GetIntegrationCookiesRequest } from 'types/api'
import { getIntegrationCookies } from 'utils/cookies'

interface StashIntegrationCookiesParams{
  getFreshData?: boolean,
  demandbaseToken?: string
}

export const stashIntegrationCookies = async (params? : Partial<StashIntegrationCookiesParams>) => {
  const getFreshData = !!params?.getFreshData || false
  const demandbaseToken = params?.demandbaseToken || ""

  let payload: Partial<GetIntegrationCookiesRequest> = {
    demandbaseToken
  }

  if (getFreshData) {
    const pardotVisitorId = getPardotVisitorId(getStoreState())
    payload['pardotId'] = pardotVisitorId
  }

  const integrationCookies = await getIntegrationCookies(payload)
  store.dispatch(receiveIntegrationCookies(integrationCookies))
  return integrationCookies
}

/**
 * Checks cookieDomain settings inside the embed to see if there's a matching cookieDomain that the widget should write cookies to
 * @returns {boolean} - whether or not we can load on the domain
 */
 export const resolveCookieDomain = (): void =>  {
  const cookieDomains = getEmbedThemeValueOrDefault(getStoreState(), 'cookieDomains', [])

  const matchesCookieDomain = (cookieDomain = "") => {
    const { url = '' } = qs.parseUrl(document.referrer)
    return url.includes(cookieDomain)
  }

  const validCookieDomain = !!cookieDomains ? cookieDomains.find(domain => matchesCookieDomain(domain)) : null
  const resolvedCookieDomain = validCookieDomain ? `.${validCookieDomain}` : null

  if (!!resolvedCookieDomain) {
    store.dispatch(receiveCookieDomain({ cookieDomain: resolvedCookieDomain }))
  }
}
